export const isAssistantRagEnabled =
  String(process.env.REACT_APP_ASSISTANT_RAG_ENABLED || 'false').toLowerCase() ===
  'true';

export const isAssistantTestPublicEnabled =
  isAssistantRagEnabled &&
  process.env.REACT_APP_ASSISTANT_TEST_PUBLIC_ENABLED === 'true' &&
  window.location.hostname === 'test.asocaguapzoga.com.ar';
